import { EstadoLiberarVentaENUM, useTableColumnsSolicitudLiberacion, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useGetFetchSupervision } from "@/shared/actions/erp/supervision.action";
import {  GeneralTable } from "@/shared/components/ui";
import { IDataSolicitudSupercion } from "@/shared/interfaces/erp/supervision/supervision.interface";
import { Grid } from "@mui/material";


const SupervicionVentaAprobadoPage = () => {
  const { columnBase } = useTableColumnsSolicitudLiberacion({
    estado_solicitud: EstadoLiberarVentaENUM.APROBADO
  });

  const {
    pagination,
    setPagination,

  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: supervicionRes,
    isRefetching, } = useGetFetchSupervision(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        estado_solicitud: EstadoLiberarVentaENUM.APROBADO,
        ...filterObject,
        filterByState: false
      }
    );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataSolicitudSupercion>
            columns={columnBase}
            data={supervicionRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={supervicionRes?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableColumnActions={true}
            enableEditing={false}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

          />
        </Grid>
      </Grid>

    </>

  );
}


export default SupervicionVentaAprobadoPage;